"use client";

/**
 * P9-07 · A slim, fixed banner shown while the browser reports no connectivity.
 * Storefront mutations (add to cart, save address…) roll back and toast on
 * failure regardless; this is the ambient signal so a shopper understands *why*
 * an action didn't stick, rather than seeing a bare error. `role="status"` +
 * `aria-live` announces the state change to assistive tech. Renders nothing
 * while online, so it costs a single boolean read the rest of the time.
 */
import { useOnlineStatus } from "~/lib/hooks/use-online-status";
import { useTranslator } from "~/i18n/provider";

export function OfflineBanner() {
  const t = useTranslator();
  const online = useOnlineStatus();
  if (online) return null;
  return (
    <div
      role="status"
      aria-live="assertive"
      className="fixed inset-x-0 top-0 z-[60] flex items-center justify-center gap-2 bg-warning px-4 py-2 text-center text-sm font-medium text-warning-fg [padding-top:calc(0.5rem+env(safe-area-inset-top))]"
    >
      <svg
        aria-hidden="true"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="shrink-0"
      >
        <path d="M1 1l22 22" />
        <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55" />
        <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39" />
        <path d="M10.71 5.05A16 16 0 0 1 22.58 9" />
        <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88" />
        <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
        <line x1="12" y1="20" x2="12.01" y2="20" />
      </svg>
      {t("nav.offline")}
    </div>
  );
}
